import CustomButton from "../../../component/elements/CustomButton/CustomButton";
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";
export default function ButtonContainer({ handleNext ,handlePrevious ,isPrev=true ,next="Next" }) {
  return (
        <div className="flex justify-end gap-3">
            {isPrev &&    <CustomButton
            onClick={handlePrevious}
            customeClass="customer-light-button w-[110px] h-[40px] text-sm"
          >
            <span className="mr-2 w-[22px] h-[22px] text-[13px] flex justify-center items-center bg-white text-[#009FE1] rounded-full ">
              <FaArrowLeft />
            </span>
            Previous
          </CustomButton>}
       
          <CustomButton
            onClick={handleNext}
            customeClass={`customer-dark-button h-[40px] text-sm ${next === "Next" ? "w-[110px]" : "w-[200px]"}`}
          >
            {next}
            <span className="ml-2 w-[22px] h-[22px] text-[13px] flex justify-center items-center bg-white text-[#009FE1] rounded-full ">
              <FaArrowRight />
            </span>
          </CustomButton>
        </div>
  );
}